import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currency' })
export class CustomCurrencyPipe implements PipeTransform {

  constructor() {}

  transform(value: any, ...args: any[]): any {
    if (value === 'USD') { return '$'; }
    if (value === 'INR') { return '₹'; }
    if (value === 'EUR') { return '€'; }
    if (value === 'GBP') { return '£'; }
    if (value === 'ILS') { return '₪'; }
    return '$'
  }

}
